import React, { FC } from 'react'
import { push } from 'connected-react-router'

import { useDispatch } from '../../store'

import './TermsAndConditions.scss'
import { NON_AUTH_ROUTE } from '../../pages/App/routes'

interface TermsAndConditionsProps {
  text:string
}

const TermsAndConditions: FC<TermsAndConditionsProps> = ({text}) => {
  const dispatch = useDispatch()

  return (
    <div className='terms-and-policy'>
      {text}{' '}
      <a
        className='terms-and-policy__inline-link'
        // onClick={() => dispatch(push(NON_AUTH_ROUTE.LOGIN))}
        href="https://attentionnest.com/terms-of-service/"
        target="_blank"
      >
        Terms & Conditions{' '}
      </a>
      and{' '}
      <a
        className='terms-and-policy__inline-link'
        // onClick={() => dispatch(push(NON_AUTH_ROUTE.LOGIN))}
        href="https://attentionnest.com/privacy-policy/"
        target="_blank"
      >
        Privacy Statement
      </a>
    </div>
  )
}

export default TermsAndConditions
